import {
  ExternalChatOrganizationSuggestion,
  isExternalChatOrganizationSuggestion,
} from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { FirestoreWhere, useCollectionStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";
import { useViewer } from "Components/Auth/AuthProvider";

export function useOrganizationSuggestionsStore() {
  const viewer = useViewer();
  const collectionRef = useRef(
    firestore().collection(CollectionPath.ORGANIZATION_SUGGESTIONS)
  );

  const sortRef = useRef(
    (
      a: ExternalChatOrganizationSuggestion,
      b: ExternalChatOrganizationSuggestion
    ) => a.createdTimestamp - b.createdTimestamp
  );

  const whereRef = useRef<FirestoreWhere[]>([
    ["userId", "==", viewer.user.uid],
  ]);

  return useCollectionStore<ExternalChatOrganizationSuggestion>({
    collection: collectionRef.current,
    where: whereRef.current,
    is: isExternalChatOrganizationSuggestion,
    sort: sortRef.current,
  });
}
